/**
 * Utility functions for credit card forms
 */

export interface ExpirationOption {
    value: string | number;
    label: string;
}

/**
 * Generate array of expiration months (01-12)
 */
export const getExpirationMonths = (): ExpirationOption[] => {
    return Array.from({ length: 12 }, (_, i) => {
        const month = i + 1;
        return {
            value: month.toString().padStart(2, '0'),
            label: month.toString().padStart(2, '0')
        };
    });
};

/**
 * Generate array of expiration years (current year + 15 years)
 */
export const getExpirationYears = (): ExpirationOption[] => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 15 }, (_, i) => {
        const year = currentYear + i;
        return {
            value: year,
            label: year.toString()
        };
    });
};

